import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth, API_URL } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import AdminNav from './AdminNav';

const NIVELES_CIVIL   = ['B1', 'B2', 'C1', 'C2'];
const NIVELES_MILITAR = ['SLP2', 'SLP3', 'SLP4', 'ACCESO_SUBOFICIAL', 'ACCESO_OFICIAL', 'CURSO_SUBOFICIAL', 'CURSO_OFICIAL'];
const NIVEL_LABEL = { SLP1:'SLP 1', SLP2:'SLP 2', SLP3:'SLP 3', SLP4:'SLP 4', ACCESO_SUBOFICIAL:'Acceso Suboficial', ACCESO_OFICIAL:'Acceso Oficial', CURSO_SUBOFICIAL:'Curso Suboficial', CURSO_OFICIAL:'Curso Oficial', B1:'B1', B2:'B2', C1:'C1', C2:'C2' };

const COLORES = {
  info:    { bg: '#EFF6FF', border: '#BFDBFE', text: '#1D4ED8', icono: 'ℹ️' },
  warning: { bg: '#FFFBEB', border: '#FDE68A', text: '#B45309', icono: '⚠️' },
  success: { bg: '#ECFDF5', border: '#A7F3D0', text: '#065F46', icono: '✅' },
  error:   { bg: '#FEF2F2', border: '#FECACA', text: '#991B1B', icono: '🚨' },
};

const formBase = () => ({
  titulo: '', mensaje: '', tipo: 'global', nivel: '', color: 'info', fecha_fin: '',
});

export default function AdminAvisos() {
  const { usuario } = useAuth();
  const navigate = useNavigate();
  const [esMobile, setEsMobile] = useState(() => window.innerWidth <= 768);
  const [lista, setLista]         = useState([]);
  const [form, setForm]           = useState(formBase());
  const [editandoId, setEditandoId] = useState(null);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [error, setError]         = useState('');

  useEffect(() => {
    const check = () => setEsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  useEffect(() => {
    if (usuario?.rol !== 'admin') { navigate('/'); return; }
    cargar();
  }, []);

  const cargar = async () => {
    try {
      const r = await axios.get(`${API_URL}/admin/control/avisos`);
      setLista(r.data);
    } catch {}
  };

  const guardar = async (e) => {
    e.preventDefault();
    setError('');
    setGuardando(true);
    try {
      const payload = { ...form, nivel: form.tipo !== 'global' && form.nivel ? form.nivel : null, fecha_fin: form.fecha_fin || null };
      if (editandoId) {
        await axios.put(`${API_URL}/admin/control/avisos/${editandoId}`, { ...payload, activo: 1 });
      } else {
        await axios.post(`${API_URL}/admin/control/avisos`, payload);
      }
      setForm(formBase());
      setEditandoId(null);
      setMostrarForm(false);
      cargar();
    } catch (e) {
      setError(e.response?.data?.error || 'Error al guardar');
    } finally { setGuardando(false); }
  };

  const toggleActivo = async (aviso) => {
    try {
      await axios.put(`${API_URL}/admin/control/avisos/${aviso.id}`, { ...aviso, activo: aviso.activo ? 0 : 1 });
      cargar();
    } catch {}
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar este aviso?')) return;
    try { await axios.delete(`${API_URL}/admin/control/avisos/${id}`); cargar(); }
    catch {}
  };

  const iniciarEdicion = (a) => {
    setForm({ titulo: a.titulo, mensaje: a.mensaje, tipo: a.tipo, nivel: a.nivel || '', color: a.color, fecha_fin: a.fecha_fin ? a.fecha_fin.slice(0, 10) : '' });
    setEditandoId(a.id);
    setMostrarForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const nivelesDisponibles = form.tipo === 'civil' ? NIVELES_CIVIL : form.tipo === 'militar' ? NIVELES_MILITAR : [];

  const inputStyle = { width: '100%', padding: '10px 14px', borderRadius: '10px', background: '#FFF0F5', border: '1px solid #FBCFE8', color: '#581C47', fontSize: '14px' };
  const btnGrad = { background: 'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)', border: 'none', color: '#fff', padding: '10px 22px', borderRadius: '50px', fontSize: '14px', fontWeight: 600, cursor: 'pointer', boxShadow: '0 4px 14px rgba(236,72,153,0.3)' };
  const btnGhost = { background: 'none', border: '1px solid #FBCFE8', color: '#BE84A3', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' };

  return (
    <div style={{ minHeight: '100vh', background: '#FFF0F5' }}>
      <AdminNav esMobile={esMobile} tipo="subpagina" titulo={esMobile ? 'Avisos' : 'Envío de Avisos'} />

      <div style={{ maxWidth: '900px', padding: esMobile ? '16px 12px 80px' : '32px 24px' }} className="fade-in">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
          <div>
            <h1 style={{ color: '#581C47', fontSize: esMobile ? '20px' : '26px', marginBottom: '4px' }}>📢 Avisos</h1>
            <p style={{ color: '#BE84A3', fontSize: '13px' }}>Mensajes visibles para los alumnos al entrar a la plataforma</p>
          </div>
          <button
            onClick={() => { setForm(formBase()); setEditandoId(null); setMostrarForm(!mostrarForm); }}
            style={{ ...btnGrad, width: esMobile ? '100%' : 'auto' }}
          >
            {mostrarForm && !editandoId ? '✕ Cancelar' : '+ Nuevo aviso'}
          </button>
        </div>

        {/* Formulario */}
        {mostrarForm && (
          <form onSubmit={guardar} style={{ background: '#FFFFFF', border: '1px solid #FBCFE8', borderRadius: '16px', padding: esMobile ? '18px 16px' : '24px', marginBottom: '24px', boxShadow: '0 4px 20px rgba(236,72,153,0.07)' }}>
            <h3 style={{ color: '#EC4899', fontSize: '15px', marginBottom: '18px' }}>{editandoId ? 'Editar aviso' : 'Crear nuevo aviso'}</h3>
            {error && <div style={{ background: 'rgba(236,72,153,0.08)', border: '1px solid rgba(236,72,153,0.25)', borderRadius: '10px', padding: '10px', color: '#DB2777', marginBottom: '14px', fontSize: '13px' }}>{error}</div>}

            <div style={{ marginBottom: '12px' }}>
              <label style={{ color: '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '5px' }}>Título *</label>
              <input style={inputStyle} value={form.titulo} onChange={e => setForm({ ...form, titulo: e.target.value })} required placeholder="Ej: Mantenimiento programado" />
            </div>
            <div style={{ marginBottom: '12px' }}>
              <label style={{ color: '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '5px' }}>Mensaje *</label>
              <textarea rows={3} style={{ ...inputStyle, resize: 'vertical' }} value={form.mensaje} onChange={e => setForm({ ...form, mensaje: e.target.value })} required placeholder="Texto del aviso que verán los alumnos" />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: esMobile ? '1fr' : '1fr 1fr 1fr 1fr', gap: '12px', marginBottom: '12px' }}>
              <div>
                <label style={{ color: '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '5px' }}>Audiencia</label>
                <select style={inputStyle} value={form.tipo} onChange={e => setForm({ ...form, tipo: e.target.value, nivel: '' })}>
                  <option value="global">🌍 Todos</option>
                  <option value="civil">🎓 Civil</option>
                  <option value="militar">🎖️ Militar</option>
                </select>
              </div>
              {form.tipo !== 'global' && (
                <div>
                  <label style={{ color: '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '5px' }}>Nivel (opcional)</label>
                  <select style={inputStyle} value={form.nivel} onChange={e => setForm({ ...form, nivel: e.target.value })}>
                    <option value="">Todos los niveles</option>
                    {nivelesDisponibles.map(n => <option key={n} value={n}>{NIVEL_LABEL[n] || n}</option>)}
                  </select>
                </div>
              )}
              <div>
                <label style={{ color: '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '5px' }}>Tipo</label>
                <select style={inputStyle} value={form.color} onChange={e => setForm({ ...form, color: e.target.value })}>
                  <option value="info">ℹ️ Informativo</option>
                  <option value="warning">⚠️ Advertencia</option>
                  <option value="success">✅ Éxito</option>
                  <option value="error">🚨 Urgente</option>
                </select>
              </div>
              <div>
                <label style={{ color: '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '5px' }}>Expira el (opcional)</label>
                <input type="date" style={inputStyle} value={form.fecha_fin} onChange={e => setForm({ ...form, fecha_fin: e.target.value })} />
              </div>
            </div>

            {/* Preview */}
            {form.titulo && (
              <div style={{ marginBottom: '18px' }}>
                <label style={{ color: '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 600 }}>Vista previa</label>
                <div style={{ background: COLORES[form.color].bg, border: `1px solid ${COLORES[form.color].border}`, borderRadius: '12px', padding: '14px 18px' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                    <span style={{ fontSize: '18px', flexShrink: 0, marginTop: '1px' }}>{COLORES[form.color].icono}</span>
                    <div>
                      <p style={{ color: COLORES[form.color].text, fontWeight: 600, fontSize: '14px', marginBottom: '4px' }}>{form.titulo}</p>
                      {form.mensaje && <p style={{ color: COLORES[form.color].text, fontSize: '13px', opacity: 0.85 }}>{form.mensaje}</p>}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <button type="submit" disabled={guardando} style={{ ...btnGrad, opacity: guardando ? 0.6 : 1 }}>
                {guardando ? 'Guardando...' : editandoId ? 'Guardar cambios' : 'Publicar aviso'}
              </button>
              <button type="button" onClick={() => { setMostrarForm(false); setEditandoId(null); }} style={btnGhost}>Cancelar</button>
            </div>
          </form>
        )}

        {/* Lista */}
        {lista.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '48px', color: '#BE84A3', background: '#FFFFFF', borderRadius: '14px', border: '1px solid #FBCFE8' }}>No hay avisos creados</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {lista.map(aviso => {
              const c = COLORES[aviso.color] || COLORES.info;
              const caducado = aviso.fecha_fin && new Date(aviso.fecha_fin) < new Date();
              return (
                <div key={aviso.id} style={{ background: '#FFFFFF', border: '1px solid #FBCFE8', borderRadius: '14px', padding: esMobile ? '14px 16px' : '16px 20px', boxShadow: '0 2px 10px rgba(236,72,153,0.05)', opacity: !aviso.activo || caducado ? 0.6 : 1 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    {/* Aviso preview */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ background: c.bg, border: `1px solid ${c.border}`, borderRadius: '10px', padding: '12px 14px', marginBottom: '10px' }}>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                          <span style={{ fontSize: '16px', flexShrink: 0 }}>{c.icono}</span>
                          <div>
                            <p style={{ color: c.text, fontWeight: 600, fontSize: '13px', marginBottom: '3px' }}>{aviso.titulo}</p>
                            <p style={{ color: c.text, fontSize: '12px', opacity: 0.85 }}>{aviso.mensaje}</p>
                          </div>
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
                        <span style={{ color: '#BE84A3', fontSize: '11px' }}>
                          {aviso.tipo === 'global' ? '🌍 Todos' : aviso.tipo === 'civil' ? `🎓 Civil${aviso.nivel ? ` · ${NIVEL_LABEL[aviso.nivel] || aviso.nivel}` : ''}` : `🎖️ Militar${aviso.nivel ? ` · ${NIVEL_LABEL[aviso.nivel] || aviso.nivel}` : ''}`}
                        </span>
                        {aviso.fecha_fin && <span style={{ color: caducado ? '#F87171' : '#BE84A3', fontSize: '11px' }}>Expira: {new Date(aviso.fecha_fin).toLocaleDateString('es-ES')}</span>}
                        <button
                          onClick={() => toggleActivo(aviso)}
                          style={{ background: aviso.activo && !caducado ? '#34D39918' : 'rgba(248,113,113,0.08)', border: `1px solid ${aviso.activo && !caducado ? '#34D39944' : 'rgba(248,113,113,0.25)'}`, color: aviso.activo && !caducado ? '#34D399' : '#F87171', padding: '3px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: 700, cursor: 'pointer' }}
                        >
                          {aviso.activo && !caducado ? '● Activo' : caducado ? '⏱ Caducado' : '○ Inactivo'}
                        </button>
                      </div>
                    </div>
                    {/* Acciones */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', flexShrink: 0 }}>
                      <button onClick={() => iniciarEdicion(aviso)} style={{ background: '#FCE7F3', border: '1px solid #FBCFE8', color: '#EC4899', padding: '6px 12px', borderRadius: '8px', fontSize: '12px', cursor: 'pointer' }}>✏️ Editar</button>
                      <button onClick={() => eliminar(aviso.id)} style={{ background: 'rgba(248,113,113,0.08)', border: '1px solid rgba(248,113,113,0.25)', color: '#F87171', padding: '6px 12px', borderRadius: '8px', fontSize: '12px', cursor: 'pointer' }}>🗑 Borrar</button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
